export enum SpecialOffer {
    CashBack20 = "Cashback_20%",
    Cashback30 = "Cashback_30%",
    AIAVitalityFitbit = "AIA_Vitality_Fitbit",
    nibPreExistingConditions = "nib_Pre_Existing_Conditions_Offer_Nov22",
    AIAOneMonthFree = "AIA_One_Month_Free_Apr2025",
    ChubbTwoMonthsFree = "Chubb_Two_Months_Free_Feb23",
    AsteronLifePrezzy = "Asteron_Life_Prezzy_Card",
    nibTwoMonthsFree = "nib_Two_Months_Free_June23",
    nibMentalHealthBenefit = "nib_Mental_Health_Benefit",
    nibHealthDiscount10 = "nib_Health_10%_discount",
    nibLifeLiving = "nib_Life_Living_200",
    CignaTraumaTwoYearsFree = "Cigna_Trauma_Two_Years_Free_Feb2022",
    AIAAirpoints = "AIA_Airpoints_Feb2022",
    AIABestDoctors = "AIA_Best_Doctors_Feb2022",
    AccuroBestDoctors = "Accuro_Best_Doctors_Feb2022",
    AsteronBestDoctors = "Asteron_Best_Doctors_Feb2022",
    PublicTrustFreeWill = "PublicTrust_Free_Will_August2022",
    nibHealthReward = "nib_Health_Reward_August2022",
    CignaSpecificInjury = "Cigna_Specific_Injury_Sept2022",
    AsteronKidsCover = "Asteron_Kids_Cover",
    SouthernCrossGP = 'SouthernCross_GP_Consultations',
    SouthernCrossMH = 'SouthernCross_Mental_Health',
    SouthernCrossDiscounts = 'SouthernCross_Discounts',
    FidelityThreeMonths = 'Fidelity_3_Months_Free',
    nibThreeMonths = 'nib_3_Months_Free',
    AIAThreeMonths = 'AIA_3_Months_Free',
    AsteronConnectedCare = 'Asteron_Connected_Care',
    FidNoPolicyFee = 'Fidelity_No_Policy_Fee'
}
